import { Injectable, Optional, Inject } from '@angular/core';
import { TranslateCompiler } from '@ngx-translate/core';
import { defaultConfig, MESSAGE_FORMAT_CONFIG, MessageFormatConfig } from 'ngx-translate-messageformat-compiler';
import MessageFormat, { MessageFormatOptions } from '@messageformat/core';


@Injectable()
export class B2BTranslateMessageFormatCompiler extends TranslateCompiler {
    private mfCache = new Map<string, MessageFormat>();
    private config: MessageFormatOptions<"string">;

    constructor(@Optional() @Inject(MESSAGE_FORMAT_CONFIG) config?: MessageFormatConfig) {
        super();

        const {
            formatters: customFormatters,
            biDiSupport,
            strictNumberSign: strict,
            currency,
            strictPluralKeys,
        } = {
            ...defaultConfig,
            ...config,
        };

        this.config = {
            customFormatters,
            biDiSupport,
            strict,
            currency,
            strictPluralKeys,
        };
    }

    compile(value: string, lang: string): (params: any) => string {
        try {
            return this.getMessageFormatInstance(lang).compile(value);
        } catch (error) {
            return () => value;
        }
    }

    compileTranslations(translations: any, lang: string): any {
        if (typeof translations === "string") {
            return this.compile(translations, lang);
        }

        return Object.keys(translations).reduce((acc, key) => {
            try {
                const value = translations[key];
                acc[key] = this.compileTranslations(value, lang);
            } catch (error) {
                acc[key] = translations[key];
            }
            return acc;
        }, {} as any);
    }

    private getMessageFormatInstance(locale: string): MessageFormat {
        if (!this.mfCache.has(locale)) {
            this.mfCache.set(locale, new MessageFormat(locale, this.config));
        }
        return this.mfCache.get(locale)!;
    }
}
